angular.module('client-group')
    .component('clientGroupPickerMultiple', {
        require: {
            ngModelCtrl: "^ngModel"
        },
        bindings: {
            ngModel: '=',
            required: "=",
            modelType: '<',
            onChange: "&"
        },
        templateUrl: "app/client-group/picker/picker-multiple.html",
        controllerAs: 'ctrl',
        controller: function ($scope, $element, $attrs, ClientGroup, uiSelectFix) {
            let ctrl = this
            ctrl.uiSelectFix = uiSelectFix

            ctrl.$onInit = () => {
                ctrl.executeOnChange = ctrl.onChange || angular.noop
                ctrl.modelTypeR = ctrl.modelType || "object"
                ClientGroup.autocomplete().$promise.then(items => ctrl.items = formatAndMap(items))
            }

            ctrl.$onChanges = () => { //changes from parent controller
                ctrl.selected = formatAndMap(ctrl.ngModel)
                ctrl.ngChange()
            }
            ctrl.ngChange = () => ctrl.ngModel = ctrl.selected

            function formatAndMap (items){
                if(!angular.isArray(items)){
                    return []
                }
                return items
                    .map(item => ({id: item.id, name: item.name}))
                    .sort((a, b) => a.name > b.name ? 1 : -1)
            }
        },
    })
